import React from 'react';

/**
 * InterviewCardSkeleton - Loading skeleton for interview cards
 * 
 * @param {string} variant - Skeleton variant: 'default', 'minimal', 'completed', 'with-notes'
 * @param {number} delay - Animation delay in milliseconds for staggered loading effect
 */
const InterviewCardSkeleton = ({ variant = 'default', delay = 0 }) => {
  const showNotes = variant === 'with-notes' || variant === 'default';
  const showHiringActions = variant === 'completed' || variant === 'default';
  
  return (
    <div 
      className="bg-surface rounded-lg border border-border p-6 animate-pulse hover:shadow-sm transition-shadow duration-200"
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Header Section */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-start space-x-4">
          {/* Avatar skeleton with gradient */}
          <div className="w-12 h-12 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full flex-shrink-0"></div>
          
          {/* Candidate info skeleton */}
          <div className="flex-1 min-w-0">
            <div className="w-32 h-5 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-2"></div>
            <div className="w-24 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-1"></div>
            <div className="w-40 h-3 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-2"></div>
            {/* Badges skeleton */}
            <div className="flex items-center space-x-2 mt-1">
              <div className="w-16 h-6 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full"></div>
              {variant !== 'minimal' && (
                <div className="w-24 h-6 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full"></div>
              )}
            </div>
          </div>
        </div>
        
       
      </div>

      {/* Grid Info Section */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          <div className="w-20 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          <div className="w-16 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          <div className="w-12 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          <div className="w-10 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
      </div>

      {/* Notes/Feedback Section (conditional) */}
      {showNotes && (
        <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-100">
          <div className="w-full h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-2"></div>
          <div className="w-3/4 h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
      )}

      {/* Action Buttons Section */}
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center space-x-3 flex-wrap gap-2">
          <div className="w-24 h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          <div className="w-20 h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          {variant !== 'minimal' && (
            <div className="w-16 h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          )}
        </div>
        
        {/* Hiring actions section (conditional) */}
        {showHiringActions && (
          <div className="flex items-center space-x-3">
            <div className="w-28 h-6 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full"></div>
            <div className="w-24 h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InterviewCardSkeleton;
